import authRules from '../authRules.js';

const removeDayTypeRequest = (user) => {
  const { deleteDaysOffRequest } = user.securityLevels;
  if (deleteDaysOffRequest >= authRules.removeDayTypeRequest.deleteDaysOffRequest) {
      return true;
  } else {
      return false;
    }
  }


export default removeDayTypeRequest;
